// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const SquareIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="SquareIcon" ref={forwardedRef} {...props}>
      <path d="M4 3a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1zm.5 1.5h11v11h-11z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const SquareIcon = /* @__PURE__ */ Object.assign(SquareIconComponent, {
  displayName: 'SquareIcon',
});
